import { JhiDataUtils } from 'ng-jhipster';

export class FileUtils {

    public static getImageBase64Format(image: any, imageContentType: string): string | undefined {
        if (image) {
            return 'data:' + imageContentType + ';base64,' + image;
        } else {
            return undefined;
        }
    }

    public static validateImageSize(event: any,
                                    minWidth: number,
                                    minHeight: number,
                                    onSuccess: () => void,
                                    onFailure: (errorMessage: string, params?: any) => void): void {
        const w = window as any;
        const url = w.URL || w.webkitURL;

        const file = event.target.files[0];
        if (!(/^image\//.test(file.type))) {
            onFailure('error.invalidImage');
        }

        const image = new Image();
        image.onload = function() {
            const width = image.naturalWidth || image.width;
            const height = image.naturalHeight || image.height;

            if (width < minWidth || height < minHeight) {
                onFailure('error.invalidImageDimensions',
                    { minWidth, minHeight });
                return;
            }

            onSuccess();
        };
        image.src = url.createObjectURL(file);
    }

    public static retrieveFileFromEvent(event: any): File | null {
        if (event && event.target.files && event.target.files.length > 0 && event.target.files[0]) {
            return event.target.files[0];
        } else {
            return null;
        }
    }

    public static setFileData(event: any,
                              dataUtils: JhiDataUtils,
                              callback: (fileData: any, fileType: string) => void) {

        const file = this.retrieveFileFromEvent(event);
        if (file) {
            dataUtils.toBase64(file, (base64Data: any) => {
                callback(base64Data, file.type);
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/file-utils.ts